import { toProxy, indexedDbUtils, IStoreWithData, Log } from '@fanfanlo'
import _ from 'lodash'
import { IPackageInfo } from './app-packages-store';

// export interface IPackageInfo{
//     label:string
//     iconBase64:string
//     packageName:string
// }

interface IData{
    list:IPackageInfo[]
}

const fileLog = new Log(false, 'app-packages-store-v2');
// fileLog.pause = true;
// fileLog.childrenPaused = true;

const data = toProxy<IData>({list:[]})
let indexedDbStore: IStoreWithData<IData> | null = null
let isInitialized = false

async function init(): Promise<void> {
    const fnLog = fileLog.sub(false, 'init_fn');
    // fnLog.pause = true;
    // fnLog.childrenPaused = true;

    if (isInitialized) {
        fnLog.log('already initialized')
        return
    }

    try {
        indexedDbStore = await indexedDbUtils.getIndexedDbStore<IData>('app-packages-v2', {
            defData: { list: [] },
            mergeDefData: false
        })

        const storedList = indexedDbStore.data.list
        if (storedList && _.isArray(storedList)) {
            data.list = storedList
        } else {
            data.list = []
        }

        isInitialized = true
        fnLog.log('complete, count=' + data.list.length)
    } catch (error) {
        fnLog.error('error=' + JSON.stringify(error))
        data.list = []
        isInitialized = false
    }
}

function loadPackages(){
    const fnLog = fileLog.sub(false, 'loadPackages_fn');
    // fnLog.pause = true;
    // fnLog.childrenPaused = true;

    if (!indexedDbStore) {
        fnLog.error('indexedDbStore is null')
        data.list = []
        return
    }

    if (!isInitialized) {
        fnLog.error('not initialized')
        data.list = []
        return
    }

    const list = indexedDbStore.data.list
    if (list && _.isArray(list)) {
        data.list = list
    } else {
        data.list = []
    }
    fnLog.log('complete, count=' + data.list.length)
}

function releasePackages(){
    const fnLog = fileLog.sub(false, 'releasePackages_fn');
    // fnLog.pause = true;
    // fnLog.childrenPaused = true;

    fnLog.log('called')
    data.list = []
}

function savePackages(list:IPackageInfo[]){
    const fnLog = fileLog.sub(false, 'savePackages_fn');
    // fnLog.pause = true;
    // fnLog.childrenPaused = true;

    if (!_.isArray(list)) {
        fnLog.error('list is not array, list=' + JSON.stringify(list))
        return
    }

    data.list = list

    if (!indexedDbStore) {
        fnLog.error('indexedDbStore is null')
        return
    }

    if (!isInitialized) {
        fnLog.error('not initialized')
        return
    }

    indexedDbStore.store.write('list', list)
    fnLog.log('complete, count=' + list.length)
}

function findPackageInfoByPackageName(packageName:string){
    const fnLog = fileLog.sub(false, 'findPackageInfoByPackageName_fn');
    // fnLog.pause = true;
    // fnLog.childrenPaused = true;

    if (!packageName) {
        fnLog.error('packageName is empty')
        return undefined
    }

    const result = data.list.find(item=>item.packageName === packageName)
    if (!result) {
        fnLog.log('not found, packageName=' + packageName + ', listCount=' + data.list.length)
    }
    return result
}

export const appPackagesStoreV2 = {
    data,
    init,
    loadPackages,
    releasePackages,
    savePackages,
    findPackageInfoByPackageName
}
